import React from 'react';
import { Modal } from 'antd';

interface IProps {
  isModalOpen: boolean;
  handleOk: () => void;
  handleCancel: () => void;
  loading: boolean;
  subjectLabel?: string; // e.g., 'segmentations' or 'predictions'
}

const ReviewModal = ({
  isModalOpen,
  handleOk,
  handleCancel,
  loading,
  subjectLabel = 'segmentations',
}: IProps) => {
  return (
    <Modal
      title="Confirm Acceptance"
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={loading}
      okText="Accept All"
      cancelText="Cancel"
    >
      <p>
        Are you sure you want to accept all {subjectLabel} on this page that are not yet reviewed?
      </p>
    </Modal>
  );
};

export default ReviewModal;
